export const ArrowUp = () => (
  <svg
    width="8"
    height="7"
    viewBox="0 0 8 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.99997 6.13178V0.605469M3.99997 0.605469L1.23682 3.36863M3.99997 0.605469L6.76313 3.36863"
      stroke="#17B26A"
      stroke-width="1.18421"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
